import { CID } from 'multiformats';
import { sha256 } from 'multiformats/hashes/sha2';
export function ensureLeadingSlash(str) {
  if (str.startsWith('/')) return str;
  return `/${str}`;
}
export async function addDagNodeToHelia(helia, codec, node, digestFn) {
  const encodedNode = codec.encode(node);
  const hash = digestFn != null ? await digestFn(encodedNode) : await sha256.digest(encodedNode);
  const cid = CID.createV1(codec.code, hash);
  return helia.blockstore.put(cid, encodedNode);
}